// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/Fonts/Mont-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/assets/Svg/elem.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/src/assets/Svg/elem2.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #202546;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace, "Mont";
}

/*  */
::-webkit-scrollbar {
  width: 12px;
}

/* Track */
::-webkit-scrollbar-track {
  background-color: #F7C338;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  -webkit-border-radius: 10px;
  background: #babac0;
  border-radius: 16px;
  border: 4px solid #F7C338;
}
::-webkit-scrollbar-thumb:window-inactive {
  background: #babac0;
}

html,
body {
  scrollbar-color: #babac0 #202546;
  scrollbar-width: thin !important ;
}

@font-face {
  font-family: "Mont";
  font-weight: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
.pending-class{
  background-color: rgba(56, 161, 222, 0.24);
  border: 1px solid #2d9cdb80;
  color: rgb(45 156 219);
  font-size: 12px;
  border-radius: 8px;
  padding: 1px 5px;
  line-height: initial;
  margin-top: -15px;
  margin-bottom: 5px;
  text-align: center;
  display: block;
  margin-right: -55px;
}

.refused-class{
  background-color: #eb57571a;
  border: 1px solid #eb575780;
  color: rgb(235 87 87);
  font-size: 12px;
  border-radius: 8px;
  padding: 1px 5px;
  line-height: initial;
  margin-top: -15px;
  margin-bottom: 5px;
  text-align: center;
  display: block;
  margin-right: -73px;
}
.accepted-class{
  background-color: #2196531a;
  border: 1px solid #21965380;
  color: rgb(33 150 83);
  font-size: 12px;
  border-radius: 8px;
  padding: 1px 5px;
  line-height: initial;
  margin-top: -15px;
  margin-bottom: 5px;
  text-align: center;
  display: block;
  margin-right: -65px;
}
.select-lang{
  border-radius: 100px !important;
  border: 1px solid #F7C338 !important;
}
input:-internal-autofill-selected {
  background-color: transparent !important;
  appearance: initial;
  background: transparent;
  background-image: none;
}

.MuiBox-root{
  background-color: #202546!important;
}
.MuiFormControlLabel-root{
  color: #ABAFB1!important;
}

.MuiStepConnector-line {
  width: 150px;
}
.MuiStep-root {
  width: 150px;
  padding: 0 !important;
}
.MuiStepLabel-iconContainer.MuiStepLabel-alternativeLabel {
  height: 11px;
  border: 0;
  background-color: #2E3350;
  border-radius: 1px;
  width: 150px;
}
.Mui-completed .MuiStepLabel-iconContainer.MuiStepLabel-alternativeLabel{
  background-color: #D7357A;
 
}
.MuiStepConnector-line {
  display: none !important;
}
.MuiStep-root:first-of-type .MuiStepLabel-iconContainer.MuiStepLabel-alternativeLabel {
  border-top-left-radius: 16px;
  border-bottom-left-radius: 16px;
}
.MuiStep-root:last-of-type .MuiStepLabel-iconContainer.MuiStepLabel-alternativeLabel {
  border-top-right-radius: 16px;
  border-bottom-right-radius: 16px;
}
.MuiStack-root {
  margin-bottom: 50px;
}
.select-lang {
  border: 1px solid white;
  color: white !important;
  height: 40px;
}
#root {
  background-color: #202546;
}
li::marker {
  color: #F7C338; 
}
table {
  border: 1px solid #F7C338 !important;
}
table th, table td {
  border: 1px solid #F7C338 !important;
}
.MuiFormControl-root-MuiTextField-root input {
font-size: 16px;}
.MuiButtonBase-root-MuiChip-root  {
  background-color: transparent;
}
.MuiButtonBase-root-MuiRadio-root  {
  color: #ABAFB1 !important;
}
.MuiFormGroup-root label span {
  color: #ABAFB1 !important;
}
body {
  position: relative;
}

.responsive-logo {
  width: 120px;
  min-width: 60px !important;
  height: auto;
}

@media (max-width: 768px) {
  .responsive-logo {
    width: 90px;
  }
  .MuiStepConnector-line {
    width: 40px;
  }
  .MuiStep-root {
    width: 40px;
    padding: 0 !important;
  }
 
}
@media (min-width:768px) {
  body::after {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    position: absolute;
    right: 0;
    top: 50%;
    z-index: 10;
  }
  body::before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    position: absolute;
    left: 0;
    top: 26%;
    z-index: 10;
  }
}

@media (max-width: 480px) {
  .responsive-logo {
    width: 60px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE;qBACmB;AACrB;;AAEA,KAAK;AACL;EACE,WAAW;AACb;;AAEA,UAAU;AACV;EACE,yBAAyB;EAEzB,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,+DAAwD;AAC1D;AACA;EACE,0CAA0C;EAC1C,2BAA2B;EAC3B,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,+BAA+B;EAC/B,oCAAoC;AACtC;AACA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;AACrC;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,yBAAyB;;AAE3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;AACA,eAAe,CAAC;AAChB;EACE,6BAA6B;AAC/B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,qBAAqB;EACvB;;AAEF;AACA;EACE;IACE,gDAAwC;IACxC,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,WAAW;EACb;EACA;IACE,gDAAyC;IACzC,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #202546;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace, \"Mont\";\n}\n\n/*  */\n::-webkit-scrollbar {\n  width: 12px;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  background-color: #F7C338;\n  -webkit-border-radius: 10px;\n  border-radius: 10px;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  -webkit-border-radius: 10px;\n  background: #babac0;\n  border-radius: 16px;\n  border: 4px solid #F7C338;\n}\n::-webkit-scrollbar-thumb:window-inactive {\n  background: #babac0;\n}\n\nhtml,\nbody {\n  scrollbar-color: #babac0 #202546;\n  scrollbar-width: thin !important ;\n}\n\n@font-face {\n  font-family: \"Mont\";\n  font-weight: normal;\n  src: url(assets/Fonts/Mont-Light.otf) format(\"truetype\");\n}\n.pending-class{\n  background-color: rgba(56, 161, 222, 0.24);\n  border: 1px solid #2d9cdb80;\n  color: rgb(45 156 219);\n  font-size: 12px;\n  border-radius: 8px;\n  padding: 1px 5px;\n  line-height: initial;\n  margin-top: -15px;\n  margin-bottom: 5px;\n  text-align: center;\n  display: block;\n  margin-right: -55px;\n}\n\n.refused-class{\n  background-color: #eb57571a;\n  border: 1px solid #eb575780;\n  color: rgb(235 87 87);\n  font-size: 12px;\n  border-radius: 8px;\n  padding: 1px 5px;\n  line-height: initial;\n  margin-top: -15px;\n  margin-bottom: 5px;\n  text-align: center;\n  display: block;\n  margin-right: -73px;\n}\n.accepted-class{\n  background-color: #2196531a;\n  border: 1px solid #21965380;\n  color: rgb(33 150 83);\n  font-size: 12px;\n  border-radius: 8px;\n  padding: 1px 5px;\n  line-height: initial;\n  margin-top: -15px;\n  margin-bottom: 5px;\n  text-align: center;\n  display: block;\n  margin-right: -65px;\n}\n.select-lang{\n  border-radius: 100px !important;\n  border: 1px solid #F7C338 !important;\n}\ninput:-internal-autofill-selected {\n  background-color: transparent !important;\n  appearance: initial;\n  background: transparent;\n  background-image: none;\n}\n\n.MuiBox-root{\n  background-color: #202546!important;\n}\n.MuiFormControlLabel-root{\n  color: #ABAFB1!important;\n}\n\n.MuiStepConnector-line {\n  width: 150px;\n}\n.MuiStep-root {\n  width: 150px;\n  padding: 0 !important;\n}\n.MuiStepLabel-iconContainer.MuiStepLabel-alternativeLabel {\n  height: 11px;\n  border: 0;\n  background-color: #2E3350;\n  border-radius: 1px;\n  width: 150px;\n}\n.Mui-completed .MuiStepLabel-iconContainer.MuiStepLabel-alternativeLabel{\n  background-color: #D7357A;\n \n}\n.MuiStepConnector-line {\n  display: none !important;\n}\n.MuiStep-root:first-of-type .MuiStepLabel-iconContainer.MuiStepLabel-alternativeLabel {\n  border-top-left-radius: 16px;\n  border-bottom-left-radius: 16px;\n}\n.MuiStep-root:last-of-type .MuiStepLabel-iconContainer.MuiStepLabel-alternativeLabel {\n  border-top-right-radius: 16px;\n  border-bottom-right-radius: 16px;\n}\n.MuiStack-root {\n  margin-bottom: 50px;\n}\n.select-lang {\n  border: 1px solid white;\n  color: white !important;\n  height: 40px;\n}\n#root {\n  background-color: #202546;\n}\nli::marker {\n  color: #F7C338; \n}\ntable {\n  border: 1px solid #F7C338 !important;\n}\ntable th, table td {\n  border: 1px solid #F7C338 !important;\n}\n.MuiFormControl-root-MuiTextField-root input {\nfont-size: 16px;}\n.MuiButtonBase-root-MuiChip-root  {\n  background-color: transparent;\n}\n.MuiButtonBase-root-MuiRadio-root  {\n  color: #ABAFB1 !important;\n}\n.MuiFormGroup-root label span {\n  color: #ABAFB1 !important;\n}\nbody {\n  position: relative;\n}\n\n.responsive-logo {\n  width: 120px;\n  min-width: 60px !important;\n  height: auto;\n}\n\n@media (max-width: 768px) {\n  .responsive-logo {\n    width: 90px;\n  }\n  .MuiStepConnector-line {\n    width: 40px;\n  }\n  .MuiStep-root {\n    width: 40px;\n    padding: 0 !important;\n  }\n \n}\n@media (min-width:768px) {\n  body::after {\n    content: url('/src/assets/Svg/elem.svg');\n    position: absolute;\n    right: 0;\n    top: 50%;\n    z-index: 10;\n  }\n  body::before {\n    content: url('/src/assets/Svg/elem2.svg');\n    position: absolute;\n    left: 0;\n    top: 26%;\n    z-index: 10;\n  }\n}\n\n@media (max-width: 480px) {\n  .responsive-logo {\n    width: 60px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
